import React, { useState } from 'react';
import { Input, FormGroup, Label } from 'reactstrap';
import * as callsActions from '../../../store/calls/actions';
import * as leadsActions from '../../../store/leads/actions';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserByRole } from '../../../selectors/user';

import Alert from '../../Common/Modal/Alert';
import { useTranslation } from 'react-i18next';
import { getFirestore, collection, doc } from 'firebase/firestore';
import rsf from '../../../helpers/firebase';
import roles from '../../../config/roles';

const personalAppointmentOptions = (users, userId, t) => {
  const removeMe = users.filter(({ id }) => id !== userId);

  const options = removeMe.map(({ id, displayName }) => ({
    value: id,
    label: displayName,
  }));

  return [
    { value: '', label: t('No') },
    { value: userId, label: t('Assign to me') },
    ...options,
  ];
};

const AppointmentAlert = ({ call, lead, isOpen, onCancel }) => {
  const users = useSelector(
    selectUserByRole(
      [roles.SUPER_ADMIN, roles.ADMIN, roles.MANAGER, roles.TEAM_LEADER],
      true,
    ),
  );

  const [appointmentDate, setAppointmentDate] = useState(
    call.appointmentDate || new Date(),
  );
  const [appointmentUserId, setAppointmentUserId] = useState(
    call.appointmentUserId || '',
  );
  const [disabledAlertBtn, setDisabledAlertBtn] = useState(false);

  const userId = useSelector((state) => state.Auth.admin.id);

  const dispatch = useDispatch();

  const handleScheduleAppointment = () => {
    setDisabledAlertBtn(true);
    const newCallId = doc(collection(getFirestore(rsf.app), 'calls')).id;

    dispatch(
      callsActions.updateCall({
        id: call.id,
        outcome: 'appointment',
        status: 'closed',
        endDateCall: new Date(),
        nextCall: newCallId,
        userId,
      }),
    );

    dispatch(
      callsActions.createCall({
        id: newCallId,
        userId: '',
        leadId: lead.id,
        leadName: lead.name,
        phone: lead.phone,
        campaignId: call.campaignId,
        countryId: call.countryId,
        acquisitionOrderId: call.acquisitionOrderId,
        sector: call.sector,
        status: 'new',
        type: 'appointment',
        appointmentDate,
        appointmentUserId,
        count: call.count,
        inbound: false,
        prevCall: call.id,
        nextCall: '',
      }),
    );
    dispatch(
      leadsActions.updateLead({
        id: call.leadId,
        qualified: 'readyToQualify',
        callId: newCallId,
      }),
    );
    onCancel();
  };

  const { t } = useTranslation();

  return (
    <Alert
      isOpen={isOpen}
      title={`${t('Schedule appointment with')}: ${lead ? lead.name : ''}`}
      confirmBtnLabel="Create"
      onCancel={onCancel}
      onConfirm={handleScheduleAppointment}
      disabledBtn={disabledAlertBtn}>
      <>
        <FormGroup>
          <Label htmlFor="appointmentDate">{t('Date')}:</Label>
          <Input
            id="appointmentDate"
            name="appointmentDate"
            className="form-control"
            type="datetime-local"
            value={appointmentDate}
            onChange={(e) => setAppointmentDate(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="isPersonal">{t('Personal appointment')}?</Label>
          <Input
            type="select"
            name="isPersonal"
            id="isPersonal"
            onChange={(e) => setAppointmentUserId(e.target.value)}
            value={appointmentUserId}>
            {personalAppointmentOptions(users, userId, t).map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
        </FormGroup>
      </>
    </Alert>
  );
};

export default AppointmentAlert;
